import { useContext } from 'react';

import TrackedExperimentsContext from './TrackedExperimentsContext';

const useTrackedExperiments = () => {
  const trackedExperimentsContext = useContext(TrackedExperimentsContext);

  if (trackedExperimentsContext === undefined) {
    throw new Error('useTrackedExperiments must be used within an TrackedExperimentsProvider');
  }

  return trackedExperimentsContext;
};

export default useTrackedExperiments;
